var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSightings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.9998C14 23.9998 17.3333 16.6665 24 16.6665C30.6667 16.6665 34 23.9998 34 23.9998C34 23.9998 30.6667 31.3332 24 31.3332C17.3333 31.3332 14 23.9998 14 23.9998Z",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 27.3332C25.841 27.3332 27.3334 25.8408 27.3334 23.9998C27.3334 22.1589 25.841 20.6665 24.0001 20.6665C22.1591 20.6665 20.6667 22.1589 20.6667 23.9998C20.6667 25.8408 22.1591 27.3332 24.0001 27.3332Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightings);
export default __webpack_public_path__ + "static/media/Sightings.32a8c49715ec76764ba2d08d77340a4a.svg";
export { ForwardRef as ReactComponent };